import { PackageDisplayData } from "@capone/packages-api";
import { actions, actionTypes } from "../actions";
import { PackagePollState } from "../actions/actions";

export interface IPackageIdentityState {
  searchKey: string | null;
  data: PackageDisplayData | null;
  pollState: PackagePollState;
}

export const initialState: IPackageIdentityState = {
  searchKey: null,
  data: null,
  pollState: "idle",
};

export const reducer = (
  // eslint-disable-next-line default-param-last -- Redux calls reducers positionally as (state, action); state must stay first
  state: IPackageIdentityState = initialState,
  action: actions.PackageIdentityActions
): IPackageIdentityState => {
  switch (action.type) {
    case actionTypes.SET_SEARCH_KEY:
      return {
        ...state,
        searchKey: action.searchKey,
      };
    case actionTypes.SET_PACKAGE_POLL_STATE:
      return {
        ...state,
        pollState: action.pollState,
      };
    case actionTypes.SET_PACKAGE_DISPLAY_DATA: {
      // Different package/session identity -> replace outright
      if (state.searchKey !== action.searchKey) {
        return {
          ...state,
          searchKey: action.searchKey,
          data: action.data,
        };
      }

      // Same identity, older snapshot -> ignore (a stale in-flight response
      // shouldn't clobber a newer one if two calls race)
      if (state.data != null && action.data.version < state.data.version) {
        return { ...state };
      }

      // Same identity, same-or-newer snapshot -> overwrite
      return {
        ...state,
        data: action.data,
      };
    }
    default:
      return { ...state };
  }
};
